const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'Navbar: Required elements not found',
	INIT_FAILED: 'Navbar: Initialization failed'
};

const CONFIG = {
	SCROLL_THRESHOLD: 50,
	CLASSES: {
		SCROLLED: 'scrolled'
	}
};

/**
 * Initialize navbar scroll behavior
 * @returns {void}
 */
const initializeNavbar = () => {
	const navbar = document.querySelector('.navbar');
	const header = document.querySelector('.header.fixed-top');

	if (!navbar || !header) {
		console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
		return;
	}

	try {
		/**
		 * Handle scroll events for navbar and header
		 * @returns {void}
		 */
		const handleScroll = () => {
			const isScrolled = window.scrollY > CONFIG.SCROLL_THRESHOLD;
			
			navbar.classList.toggle(CONFIG.CLASSES.SCROLLED, isScrolled);
			header.classList.toggle(CONFIG.CLASSES.SCROLLED, isScrolled);
		};

		// Add scroll event listener
		window.addEventListener('scroll', handleScroll, { passive: true });

		// Initialize state
		handleScroll();
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeNavbar };
